export class ProviderService {

  public id: string;

  public url: string;
  public slug: string;
  public name: string;
  public nameTranslations: Object;
  public root  : string;
  public children: any;
  public childrenPickMin: number;
  public minimalPrice  : string;
  public visibleForCustomers  : string;
  public visibleForEditors  : string;
  public visibleByDefaultInAdmin  : string;
  public shortDescription  : string;
  public longDescription  : string;
  public descriptionButtonText  : string;
  public descriptionButtonTextTranslations  : Object;
  
  public avatar : any;
  public menuOpen : number;
  public event : boolean;
  public exclusiveEvent : boolean;
  public specialOffer : boolean;
  public productPickRequired : boolean;
  public newService : boolean;

  public lft: number;
  public lvl: number;
  public rgt: number;

  public regularPrice1 : number;
  public regularPrice2 : number;
  public regularPrice3 : number;
  public regularPrice4 : number;
  public regularPrice5 : number;
  public regularPrice6 : number;
  public regularPrice7 : number;
  public regularPrice8 : number;
  public regularPrice9 : number;

  public noShowProtection: boolean;
  public noShowMaxPenaltyPerPerson: number;
  public paymentRequired: boolean;
  public minSpendRequired: boolean;
  public minSpendAmount: number;
  public cancellationPeriod: number;
  public cancellationPeriodForGroups: number;

  public confirmationNeededPartySize: number;
  public contactUsPartySize: number;

  public start: string;

  public _self: string;

  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id || null;
    this.url = obj && obj.url || null;
    this.name = obj && obj.name || null;
    this.slug = obj && obj.slug || null;
    this.descriptionButtonText = obj && obj.descriptionButtonText || null;
    this.nameTranslations = obj && obj.nameTranslations || null;
    this.descriptionButtonTextTranslations = obj && obj.descriptionButtonTextTranslations || null;
    this.root = obj && obj.root || null;
    this.children = obj && obj.children || null;
    this.childrenPickMin = obj && obj.childrenPickMin || null;
    this.minimalPrice = obj && obj.minimalPrice || null;
    this.visibleForCustomers = obj && obj.visibleForCustomers || null;
    this.visibleForEditors = obj && obj.visibleForEditors || null;
    this.visibleByDefaultInAdmin = obj && obj.visibleByDefaultInAdmin || null;
    this.shortDescription = obj && obj.shortDescription || null;
    this.longDescription = obj && obj.longDescription || null;
    this.descriptionButtonText = obj && obj.descriptionButtonText || null;
    this.avatar = obj && obj.avatar || null;
    this.menuOpen = obj && obj.menuOpen || false;

    this.event = obj && obj.event || false;
    this.exclusiveEvent = obj && obj.exclusiveEvent || false;
    this.specialOffer = obj && obj.specialOffer || false;
    this.productPickRequired = obj && obj.productPickRequired || false;
    this.newService = obj && obj.newService || false;

    this.lft = obj && obj.lft || null;
    this.lvl = obj && obj.lvl || null;
    this.rgt = obj && obj.rgt || null;

    this.regularPrice1 = obj && obj.regularPrice1 || null;
    this.regularPrice2 = obj && obj.regularPrice2 || null;
    this.regularPrice3 = obj && obj.regularPrice3 || null;
    this.regularPrice4 = obj && obj.regularPrice4 || null;
    this.regularPrice5 = obj && obj.regularPrice5 || null;
    this.regularPrice6 = obj && obj.regularPrice6 || null;
    this.regularPrice7 = obj && obj.regularPrice7 || null;
    this.regularPrice8 = obj && obj.regularPrice8 || null;
    this.regularPrice9 = obj && obj.regularPrice9 || null;

    this.noShowProtection = obj && obj.noShowProtection || null;
    this.noShowMaxPenaltyPerPerson = obj && obj.noShowMaxPenaltyPerPerson || null;
    this.paymentRequired = obj && obj.paymentRequired || null;
    this.minSpendRequired = obj && obj.minSpendRequired || null;
    this.minSpendAmount = obj && obj.minSpendAmount || null;

    this.cancellationPeriod = obj && obj.cancellationPeriod || null;
    this.cancellationPeriodForGroups = obj && obj.cancellationPeriodForGroups || null;

    this.start = obj && obj.start || null;

    //@todo Please remove after api deploy
    if ( obj.shortHair ) {
      obj.confirmationNeededPartySize = 1;
    }

    this.confirmationNeededPartySize = obj && obj.confirmationNeededPartySize || null;
    this.contactUsPartySize = obj && obj.contactUsPartySize || null;

    if ( obj && obj._self ) {
      this._self = obj._self;
    } else if ( obj && obj._links && obj._links.self && obj._links.self.href ) {
      this._self = obj._links.self.href;
    }
    
  }

}